import { Link, LinkProps } from '@chakra-ui/react';
import { t } from '@transifex/native';
import { MAIN_CONTENT_ID } from './LayoutMain';

export const SkipToMainContent = (props: LinkProps) => {
	return (
		<Link
			href={`#${MAIN_CONTENT_ID}`}
			position="absolute"
			left="4"
			top="4"
			zIndex={9999}
			bg="white"
			color="black"
			px="3"
			py="2"
			borderRadius="md"
			fontWeight="medium"
			lineHeight="short"
			transform="translateY(-200%)"
			transition="transform 0.2s ease-in-out"
			_focus={{
				transform: 'translateY(0)',
				boxShadow: 'outline',
				outline: 'none',
			}}
			_focusVisible={{
				transform: 'translateY(0)',
				boxShadow: 'outline',
				outline: 'none',
			}}
			{...props}
		>
			{t('Skip to main content')}
		</Link>
	);
};
